/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ProductProps } from '@components/tickets/StoresSaleProductList'
import { TicketVariant } from '@lib/TicketVariantContext'
import { Width } from '@ts/css'
import { Maybe, StoresTicketSalesPageLayoutFragment } from '@ts/operations'
import React from 'react'

import BenefitsGrid, { Benefit } from './BenefitsGrid'

const StoresTicketBenefitsComparator = ({
  benefitsList,
  products,
  labelsColumnWidth,
}: {
  benefitsList?: StoresTicketSalesPageLayoutFragment['benefitsList'] | null
  labelsColumnWidth?: Width
  products: ProductProps[]
}) => {
  const items: Array<{
    dealId?: Maybe<string>
    id?: string
    variant: TicketVariant
  }> = products.map(({ id, dealId, promoted, type }) => {
    let variant: TicketVariant = TicketVariant.Standard
    if (promoted) variant = TicketVariant.Promoted
    if (type === 'soldOut') variant = TicketVariant.SoldOut
    return {
      dealId,
      id,
      variant,
    }
  })

  let benefits: Benefit[] = []
  benefitsList?.forEach(({ id: benefitId, title, description }) => {
    products?.forEach(({ id: productId, tags }) => {
      const currentBenefit: Benefit | undefined = benefits?.find(t => t.id === benefitId)
      const hasProduct = tags?.find(b => b.id === benefitId)
      if (!currentBenefit) {
        benefits = [
          ...benefits,
          {
            description: description || '',
            id: benefitId,
            itemIds: hasProduct ? [productId] : [],
            title: title || '',
          },
        ]
      } else if (currentBenefit && hasProduct) {
        currentBenefit.itemIds = currentBenefit.itemIds && [...currentBenefit.itemIds, productId]
      }
    })
  })

  return <BenefitsGrid benefits={benefits} items={items} labelsColumnWidth={labelsColumnWidth} />
}
export default StoresTicketBenefitsComparator
